import { render, staticRenderFns } from "./InventoryManual.vue?vue&type=template&id=20ea62ce&"
import script from "./InventoryManual.vue?vue&type=script&lang=js&"
export * from "./InventoryManual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports